import React, { FC, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useWindowSize } from "go-core/components/useWindowSize";
import { FormDirty } from "go-form/components/FormDirty";
import { CompanyApi } from "../../../../../../../../../services/Api/Organization/types";
import { api } from "../../../../../../../../../services/Api/api";
import BankAccountsForm from "./BankAccountsForm";

interface Props {
	company: CompanyApi;
}

const CompanyForm: FC<Props> = ({ company }) => {
	const { t } = useTranslation();
	const { addFlash, addSuccessFlash } = useFlash();
	const form = useForm<CompanyApi>({
		criteriaMode: "all",
		defaultValues: { ...company },
	});
	const {
		setError,
		register,
		formState,
		formState: { errors },
		handleSubmit,
		reset,
	} = form;
	const [loading, setLoading] = useState<boolean>(false);
	const isMobile = useWindowSize().isMobile;

	const onSubmit = handleSubmit(async (data: CompanyApi) => {
		setLoading(true);
		try {
			const params = { include: "bank_accounts" };
			const res = await api.organization().updateCompany(data, params);
			reset(res);
			addSuccessFlash(t("common.flash.saved", { ns: "lib" }));
		} catch (err) {
			handleError.form(err, setError, addFlash);
		}
		setLoading(false);
	});

	return (
		<FormDirty formState={formState} noValidate onSubmit={onSubmit} key="company-form" loading={loading}>
			<h5 className={isMobile ? "mt-2" : "mt-0"}>{t("lib:common.word.basic_data")}</h5>
			<fieldset className="form-group">
				<div className="row">
					<div className="col-md-6">
						<FormInput
							name="company_name"
							errors={errors}
							register={register}
							label={t("lib:common.word.name")}
						/>
					</div>
					<div className="col-md-6">
						<FormInput
							name="tax_id_no"
							errors={errors}
							register={register}
							label={t("lib:common.word.tax_id_no.title")}
						/>
					</div>
				</div>
			</fieldset>
			<fieldset>
				<h5>{t("modules.company.field.bank_accounts.title")}</h5>
				<BankAccountsForm form={form} />
			</fieldset>
		</FormDirty>
	);
};

export default CompanyForm;
